// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1hhIC","main":"Header_main__226xC","loadingBar":"Header_loadingBar__DnXru"};